import React from "react"
import {Typography, Container, Divider, Button} from '@mui/material'
import {Link} from "react-router-dom"
import styled from "styled-components";
import img from "../../Images/profile.jpg"
import {makeStyles} from "@mui/styles"
import {createTheme} from "@mui/material/styles"
import Download from '@mui/icons-material/Download';

const theme = createTheme()


const useStyles = makeStyles({
    about:{
        width:"60%",
        [theme.breakpoints.down("sm")]:{
            width:'auto'
        }
    },

    typo:{
        width:"60%",
        textAlign:"justify",
        fontWeight:"bold",
        marginTop:"1rem",
        [theme.breakpoints.down("sm")]:{
            width:"auto"
        }
    },

    me:{
        display:"flex",
        justifyContent:"space-between",
        [theme.breakpoints.down("sm")]:{
            flexDirection:"column"
        }
    }
})

const Image = styled.img`
    width: 30%;
@media screen and (max-width:768px){
    width:300px;
    height:300px;
    text-align:center;
    border-radius:50%
}
   
`

const AboutMe = () =>{
    const classes = useStyles()

    return(
        <Container maxWidth="lg" id="about">
        <div className={classes.me}>
            <Image src={img} alt="my picture" />
            <div className={classes.about}>
        <Typography variant="h4" data-aos="zoom-in-down">About Me</Typography>
        <Divider />
        
        <div className={classes.typo} data-aos="fade-up-left">
        <Typography variant="body1" paragraph>I'm Olawuni Olukunle a Full-Stack Developer, specialising in core Full Stack technologies such
        as React, MongoDB, Express, Node, JavaScript, Redux, Typescript and Material UI.</Typography>
        <Typography variant="body1" paragraph>Well-organised person, problem solver, independent employee with high 
            attention to detail. Fan of outdoor activities and TV series.
        </Typography>

        <Typography variant="body1">Interested in the entire full stack spectrum and working on ambitious projects with positive people</Typography>
        <Button variant="contained" style={{marginTop:"3rem"}} 
        endIcon={<Download />} component={Link} to="/files/CV1.pdf" target="_blank" download>Download my CV</Button>


        
        </div>
        </div>
        </div>


        </Container>
        

    )
}

export default AboutMe

// https://jonny.me/